import React, { useState } from 'react';
import { getClassName } from '@onsolve/utils.get-class-name';
import styles from './Question.module.scss';
import { Button, Typography, LoadingSpinner } from '@onsolve/onsolve-ui-components';
import StickyButtonBar from './StickyButtonBar';
import { t } from '@lingui/macro';
import Followup from './Followup';
const Question = ({ saveAnswer, saveResponse, isLoading, currentFollowUps, isDone, key }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'responseOptionQuestion-page',
        styles,
    });
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    const handleResponseOptionChange = (selectionValue) => {
        currentFollowUps['response'] = selectionValue;
    };
    const handleTextAreaChange = (textareaValue) => {
        currentFollowUps['response'] = textareaValue;
    };
    const saveQuestionResponse = (event) => {
        saveResponse(currentFollowUps);
        setIsSaveDisabled(true);
    };
    const saveFinalQuestionResponse = (event) => {
        saveResponse(currentFollowUps);
        saveAnswer(undefined);
        setIsSaveDisabled(true);
    };
    const isSaveBtnDisabled = (value) => {
        setIsSaveDisabled(value);
    };
    return (<>
            <div className={`${rootClass} pt-4 px-4 overflow-auto flex-grow-1`}>
                <Typography variant={'p18'} className="m-0">
                    {t `Alert Reply`}
                </Typography>
                {isLoading ? (<div className="mx-auto text-center my-4">
                        <LoadingSpinner logoType={'newLogo'} size="xxl"/>
                    </div>) : (<div className={getChildClass('responseOption-wrapper')}>
                        {currentFollowUps && (<Typography variant={'p16'} className="mt-2 mb-4">
                                {t `You have received the following message. Please select a response option (if any) and click
                        `}{' '}
                                <b>{t `Save`}</b>, {t `or click`} <b>{t `Back`}</b>{' '}
                                {t `if no response is being requested to this message.`}
                            </Typography>)}

                        {currentFollowUps && (<Followup currentFollowUp={currentFollowUps} handleResponseOptionChange={handleResponseOptionChange} handleTextAreaChange={handleTextAreaChange} key={currentFollowUps?.id} isSaveBtnDisabled={isSaveBtnDisabled}/>)}
                    </div>)}

                <StickyButtonBar rightContent={<>
                            <Button variant="raised" onClick={() => {
                location.reload();
            }}>
                                {t `CANCEL`}
                            </Button>
                            {!isDone && (<Button color="primary" variant="raised" className="px-4" onClick={saveQuestionResponse} disabled={isSaveDisabled}>
                                    {t `SAVE`}
                                </Button>)}
                            {isDone && (<Button color="primary" variant="raised" className="px-4" onClick={saveFinalQuestionResponse} disabled={isSaveDisabled}>
                                    {t `DONE`}
                                </Button>)}
                        </>}/>
            </div>
        </>);
};
export default Question;
